export default __webpack_public_path__ + "static/media/androgenetic-alopeciap.ccf6347e.pdf";